// Custom Hillsify Oleg: Minimum order warning — shared logic — 2026-04-12

(function () {
  // The drawer re-renders its own init <script> on every update, so the same
  // triplet would subscribe again and again.
  var registered = {};

  function moneyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function render(ids, cartData) {
    // Look the nodes up per event. The drawer replaces .drawer__inner (and
    // sometimes #CartDrawer) wholesale, so anything cached would be detached
    // and this handler would write into nodes nobody can see.
    var warningEl = document.getElementById(ids.warning);
    var warningText = document.getElementById(ids.text);
    var checkoutBtn = document.getElementById(ids.checkout);
    if (!warningEl || !warningText || !checkoutBtn) return;

    var minCents = parseInt(warningEl.dataset.hfoMinCents, 10);
    var exemptIds = (warningEl.dataset.hfoExemptIds || '').split(',').filter(Boolean);
    var msgError = warningEl.dataset.hfoMsgError; // {minimum} substituted, {remaining} still a placeholder
    var msgMixed = warningEl.dataset.hfoMsgMixed;

    var totalPrice = cartData.items_subtotal_price;
    var itemCount = cartData.item_count;
    var items = cartData.items || [];

    if (itemCount === 0) {
      warningEl.hidden = true;
      checkoutBtn.disabled = true;
      return;
    }

    var exemptCount = 0;
    var regularCount = 0;
    var exemptTitles = [];
    var seenExemptIds = {};
    items.forEach(function (item) {
      if (exemptIds.indexOf(String(item.product_id)) !== -1) {
        exemptCount++;
        if (!seenExemptIds[item.product_id]) {
          seenExemptIds[item.product_id] = true;
          exemptTitles.push(item.product_title);
        }
      } else {
        regularCount++;
      }
    });

    // Scenario 1: all exempt — no warning, button active
    if (exemptCount > 0 && regularCount === 0) {
      warningEl.hidden = true;
      checkoutBtn.disabled = false;
      return;
    }

    // Minimum met — no warning, button active
    if (totalPrice >= minCents) {
      warningEl.hidden = true;
      checkoutBtn.disabled = false;
      return;
    }

    // Scenario 2 or 3: show warning, block button
    var remainingVal = Math.ceil((minCents - totalPrice) / 100);
    var remainingHtml = '<strong>' + remainingVal + '</strong>';
    var template = (exemptCount > 0 && regularCount > 0) ? msgMixed : msgError;
    var productsHtml = exemptTitles.map(function (t) { return '<strong>' + t + '</strong>'; }).join(', ');
    warningText.innerHTML = template.replace('{remaining}', remainingHtml).replace('{products}', productsHtml);
    warningEl.hidden = false;
    checkoutBtn.disabled = true;
  }

  function handle(ids, event) {
    var cartData = event && event.cartData;

    // product-form publishes the /cart/add.js response on this same event, and
    // that payload is the added line item, not a cart: no items_subtotal_price,
    // no item_count, no items. Reading it produced "Es fehlen noch NaN €" and
    // unblocked checkout, so fetch the real cart instead.
    if (cartData && typeof cartData.items_subtotal_price === 'number') {
      render(ids, cartData);
      return;
    }

    fetch(moneyRoot() + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(ids, cart); })
      .catch(function () { /* leave the server-rendered state alone */ });
  }

  window.hfoInitMinOrderWarning = function (warningId, warningTextId, checkoutId) {
    var key = warningId + '|' + warningTextId + '|' + checkoutId;
    if (registered[key]) return;
    registered[key] = true;

    var ids = { warning: warningId, text: warningTextId, checkout: checkoutId };
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      handle(ids, event);
    });
  };
})();
